import { twMerge } from 'tailwind-merge';

import { cs } from '@/_shared';

export const componentsStyles = (
  isMulti?: boolean,
  disabled?: boolean,
  menuClassName?: string,
  menuListClassName?: string,
  optionClassName?: string,
  singleValueClassName?: string,
  multiValueClassName?: string,
  className?: string,
  inputClassName?: string,
  valueContainerClassName?: string
) => ({
  container: () => twMerge(`relative ${isMulti ? '' : 'h-11'} w-full min-w-20`, className),
  indicatorSeparator: () => 'bg-outline! dark:bg-gray-600 hidden',
  placeholder: () => 'hidden!',
  dropdownIndicator: () => `py-1! pr-0! text-accent-light! cursor-pointer [&>svg]:size-4 ${disabled ? 'hidden!' : ''}`,
  singleValue: () =>
    twMerge(`text-c-card-foreground! font-sans text-sm font-normal normal-case!`, singleValueClassName),
  valueContainer: () => twMerge('pt-0.75! pb-1! pl-0!', valueContainerClassName),
  input: () =>
    twMerge(
      'text-c-card-foreground! placeholder-shown:border-c-border cursor-text font-sans text-sm font-normal normal-case! placeholder:text-transparent',
      inputClassName
    ),
  menu: () =>
    twMerge(
      'border-c-border-muted z-99999! border bg-white py-2.5! pr-0! pl-1! shadow-md! dark:bg-gray-950!',
      'rounded-xl!',
      cs('rounded-4xl!'),
      menuClassName
    ),

  menuList: () => menuListClassName || '',
  groupHeading: () =>
    `text-accent! sticky -top-1.5 mb-0! pb-1.5 bg-white text-sm! font-sans font-extrabold! capitalize dark:text-white! dark:bg-gray-950!`,
  option: ({ isFocused }: { isFocused: boolean }) =>
    twMerge(
      'react-my-0.5 text-c-card-foreground! cursor-pointer! rounded-xl bg-transparent! px-3 py-2 text-sm! leading-tight outline-hidden transition-all select-none',
      'hover:text-accent! hover:bg-gray-200! dark:hover:bg-gray-900! dark:hover:text-white!',
      isFocused && 'text-accent! bg-gray-200! dark:bg-gray-900! dark:text-white!',
      optionClassName
    ),

  multiValue: () =>
    twMerge(
      `[&>*:last-child:hover]:bg-error-medium! *:text-accent cursor-pointer rounded-lg! bg-gray-200! py-0! select-none dark:bg-gray-800! dark:*:text-gray-400! [&>*:last-child]:rounded-lg! [&>*:last-child:hover]:text-white! ${disabled ? 'pr-0.5! [&>*:last-child]:hidden' : ''} text-accent-light! font-sans text-sm! capitalize`,
      multiValueClassName
    ),
  clearIndicator: () => `p-0! text-accent-light! cursor-pointer [&>svg]:size-4`,
});
